import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, UserIcon, TrashIcon, LogOutIcon } from 'lucide-react';
export const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-210">
      <button onClick={() => setIsOpen(!isOpen)} className="p-4 w-full flex items-center gap-3 hover:bg-[#2a2a2a] transition-colors border-t border-[#444444]" aria-expanded={isOpen} aria-haspopup="true" data-id="element-211">
        <div className="w-8 h-8 rounded-full bg-[#555555] flex items-center justify-center font-medium text-sm flex-shrink-0" data-id="element-212">
          GS
        </div>
        <span className="font-medium flex-grow text-left" data-id="element-213">Guest Session</span>
        <ChevronDownIcon size={16} className={`text-[#888888] transition-transform duration-200 ${isOpen ? '' : 'rotate-180'}`} data-id="element-214" />
      </button>
      {isOpen && <div className="absolute bottom-full left-0 w-full bg-[#1a1a1a] border border-[#444444] rounded-t-lg shadow-lg overflow-hidden" data-id="element-215">
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm" data-id="element-216">
            <UserIcon size={16} className="text-[#888888]" data-id="element-217" />
            <span data-id="element-218">Assistants</span>
          </button>
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm" data-id="element-219">
            <TrashIcon size={16} className="text-[#888888]" data-id="element-220" />
            <span data-id="element-221">Clear History</span>
          </button>
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm text-[#ff4444]" data-id="element-222">
            <LogOutIcon size={16} data-id="element-223" />
            <span data-id="element-224">Logout</span>
          </button>
        </div>}
    </div>;
};